<div class="h-screen flex flex-col">
  <app-wait></app-wait>
  <router-outlet></router-outlet>
  <app-notification-toast />
</div>
